import {ArianeElement, ArianeStore, ModalService} from "@digicerba/common";
import {FormationDto, IFormationWebServiceClient} from "@resources/resources";
import {ActivatedRoute} from "@angular/router";
import {AsiTable, AsiTableData} from "@asi-ngtools/lib";
import {Component, ViewChild} from "@angular/core";
import * as lodash from "lodash";

@Component({
  selector: 'admin-formation-component',
  templateUrl: './admin.formation.component.html',
  host: {'class': 'page'}
})
export class AdminFormationComponent {

  @ViewChild('cmFormationDataTable') formationTable: AsiTable<FormationDto>;
  asiTableData: AsiTableData<FormationDto> = new AsiTableData<FormationDto>();

  constructor(private arianeStore: ArianeStore, private activatedRoute: ActivatedRoute, private modalService: ModalService, private formationWebServiceClient: IFormationWebServiceClient) {
    let arianeElements: Array<ArianeElement>;
    arianeElements = [
      {
        libelle: "Catalogue de formation",
        route: "/liste-formations"
      },
      {
        libelle: "Administration",
        route: "/administration"
      }
    ];

    arianeStore.updateElements(arianeElements);
  }

  ngOnInit() {
    this.asiTableData.results = this.activatedRoute.snapshot.data['formations'];
  }

  ngAfterContentInit() {
    this.formationTable.updateData(this.asiTableData);
  }

  openDeleteModal(id: number) {
    this.modalService.openConfirmDialog("MODAL.ADMIN.SUPPRESSION_FORMATION.title", "MODAL.ADMIN.SUPPRESSION_FORMATION.message",
      "MODAL.ADMIN.SUPPRESSION_FORMATION.cancel", "MODAL.ADMIN.SUPPRESSION_FORMATION.confirm").onDialogCancel().subscribe(() => {
      this.formationWebServiceClient.deleteFormation(id).subscribe(response => {
        response;
        lodash.remove(this.asiTableData.results, function (o) {
          return o.id == id;
        });
        this.formationTable.updateData(this.asiTableData);
      }, error => {
        this.modalService.openInfoDialog("MODAL.ADMIN.SUPPRESSION_FORMATION_IMPOSSIBLE.title", "MODAL.ADMIN.SUPPRESSION_FORMATION_IMPOSSIBLE.message",
          "MODAL.ADMIN.SUPPRESSION_FORMATION_IMPOSSIBLE.confirm").onDialogClose().subscribe(() => {
          lodash.forEach(this.asiTableData.results, function (row) {
            if (row.id == id) {
              // FIXME
              row.nombrePlacesReservees++;
            }
          });
        });
      });
    });
  }

  openArchiveModal(id: number) {
    this.modalService.openConfirmDialog("MODAL.ADMIN.ARCHIVE_FORMATION.title", "MODAL.ADMIN.ARCHIVE_FORMATION.message",
      "MODAL.ADMIN.ARCHIVE_FORMATION.cancel", "MODAL.ADMIN.ARCHIVE_FORMATION.confirm").onDialogCancel().subscribe(() => {
      this.formationWebServiceClient.archiveFormation(id).subscribe(response => {
        response;
        lodash.remove(this.asiTableData.results, function (o) {
          return o.id == id;
        });
        this.formationTable.updateData(this.asiTableData);
      }, error => {
        console.log(error);
      });
    });
  };


  isDeletable(row: FormationDto): boolean {
    return row.nombrePlacesReservees == 0;
  }

}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-catalogue-formation/digicerba-catalogue-formation-web/src/angular/cerba/src/app/pages/cerba/pages/administration/formation/admin.formation.component.ts